import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "text-3xl"
};
import LoadingLayout from "@/modules/base/layouts/LoadingLayout.vue";
import { Match } from "@/modules/match/entity";
import MatchPanel from "@/modules/diplomacy/components/MatchPanel.vue";
import { app } from "@/di";
import { DayEvaluator } from "@/modules/season/services/DayEvaluator";
import UserMatchHandler from "@/modules/match/services/UserMatchHandler";
import BeforeMatchMode from "@/modules/match/services/BeforeMatchMode";
export default /*#__PURE__*/_defineComponent({
  __name: 'MatchEvaluationAfter',
  async setup(__props) {
    let __temp, __restore;
    const route = useRoute();
    const router = useRouter();
    const match = ref();
    const ready = ref(true);
    const {
      refresh
    } = ([__temp, __restore] = _withAsyncContext(async () => useInitial(async () => {
      match.value = await Match.createQueryBuilder('match').innerJoinAndSelect('match.homeTeam', 'homeTeam').innerJoinAndSelect('match.awayTeam', 'awayTeam').innerJoinAndSelect('match.matchday', 'matchday').innerJoinAndSelect('matchday.division', 'division').innerJoinAndSelect('division.competition', 'competition').leftJoinAndSelect('homeTeam.players', 'homePlayer').leftJoinAndSelect('awayTeam.players', 'awayPlayer').leftJoinAndSelect('match.incidents', 'incident').leftJoinAndSelect('incident.player', 'incidentPlayer').where('match.id = :matchId', {
        matchId: route.params.id
      }).getOneOrFail();
    })), __temp = await __temp, __restore(), __temp);
    const dayEvaluator = app.get(DayEvaluator);
    onMounted(async () => {
      await app.get(UserMatchHandler).continue();
      await app.get(BeforeMatchMode).disable();
    });
    watch(() => dayEvaluator.isCalculating.value, async value => {
      if (!value) {
        // todo really needed? with regular amount of teams, too slow?
        await waitFor(3000);
        router.push({
          name: 'index'
        });
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(LoadingLayout, {
        "hide-loader": ""
      }, {
        default: _withCtx(() => [_createVNode(MatchPanel, {
          match: match.value,
          class: "my-8 w-full"
        }, null, 8, ["match"]), _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('processing...')), 1)]),
        _: 1
      });
    };
  }
});